import { Dispatch } from '../../../../../types/actions';
import { ISnackbarModel } from '../../store/types';
import { snackbarInfoDefault } from './infoDefault';

export const snackbarUserInfoDefault = (
    options: ISnackbarModel
) => {
    return (dispatch: Dispatch) => {
        if (options.icon === undefined) {
            options.icon = 'account';
        }
        dispatch(snackbarInfoDefault(options));
    }
};
